import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Constants } from './../../shared/constants';
import { StorageService } from './../../shared/services/storage.service';


@Injectable({
  providedIn: 'root'
})

export class AboutUsService {

  constructor(private http: HttpClient, private storageService: StorageService) { }


  // Get Customer Quotes of logged in user from Jamestown GET Request
  getCustomerQuotes(): Observable<any> {
    return this.http.get(`${Constants.baseURL}/customerQuotes/`);
  }


  // Get Our Crew of logged in user from Jamestown GET Request
  getOurCrew(): Observable<any> {
    return this.http.get(`${Constants.baseURL}/ourCrew/`);
  }

}
